// src/components/LoginPage.jsx
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "./LoginPage.css";
import logo from '../Assets/logo.png'
import Sidebar from "./sidebar";
import Footer from "./Footer";
export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || "Unable to sign in. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };
  
  return (
    <div>
    <div className="tm-login-shell tm-login-shell--desktop-offset">
        <Sidebar />
      {/* Left brand strip (mimics red sidebar header) */}
      
      <div className="tm-login-brand">
         <div className="tm-logo">
                <img src={logo} alt="Custom Logo" />
              <div className="header-info">
                <p className="company-name">Table Mate</p>
                <p className="site-title">Back End Server Application</p>
              </div>
            </div>

        <div className="tm-login-brand-copy">
          <div className="tm-login-brand-heading">Data Centre Login</div>
          <p className="tm-login-brand-body">
            Secure access to your sales, tables, ratings, and menu analytics.
          </p>
        </div>
      </div>

      {/* Right form card */}
      <div className="tm-login-main">
        <div className="tm-login-card">
          <h1 className="tm-login-title">Sign in</h1>
          <p className="tm-login-subtitle">
            Use your Table Mate admin credentials to continue.
          </p>

          {error && <div className="tm-login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="tm-login-form">
            <div className="tm-login-field">
              <label htmlFor="email" className="tm-login-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="tm-login-input"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="tm-login-field">
              <label htmlFor="password" className="tm-login-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="tm-login-input"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              className="tm-login-button"
              disabled={submitting}
            >
              {submitting ? "Signing in..." : "Sign In"}
            </button>

            <Link to="/forgot-password" className="tm-login-forgot">
              Forgot password?
            </Link>

            <div className="tm-login-helptext">
              Having trouble? Contact your system administrator.
            </div>
          </form>
        </div>

        <div className="tm-login-footer">
          <Footer></Footer>
        </div>
        
      </div>
      
    </div>
   
    </div>
  );
}
